// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__n4cSo","buttons":"PendingPaymentAlert_buttons__2zpO-"};